export interface AchievementDef {
  id: string;
  name: string;
  description: string;
  category: 'completion' | 'mastery' | 'streak' | 'misc';
}

export const ACHIEVEMENTS: AchievementDef[] = [
  { id: 'first_step', name: 'First Step', description: 'Complete your first level', category: 'completion' },
  { id: 'world_1', name: 'Warehouse Graduate', description: 'Complete all World 1 levels', category: 'completion' },
  { id: 'world_2', name: 'Shipping Expert', description: 'Complete all World 2 levels', category: 'completion' },
  { id: 'world_3', name: 'Factory Foreman', description: 'Complete all 100 levels', category: 'completion' },
  { id: 'star_collector', name: 'Star Collector', description: 'Earn 50 stars', category: 'mastery' },
  { id: 'star_master', name: 'Star Master', description: 'Earn 200 stars', category: 'mastery' },
  { id: 'perfectionist', name: 'Perfectionist', description: 'Get 3 stars on 10 levels', category: 'mastery' },
  { id: 'getting_started', name: 'Getting Started', description: 'Reach a 3-day streak', category: 'streak' },
  { id: 'dedicated', name: 'Dedicated', description: 'Reach a 7-day streak', category: 'streak' },
  { id: 'unstoppable', name: 'Unstoppable', description: 'Reach a 30-day streak', category: 'streak' },
  { id: 'explorer', name: 'Explorer', description: 'Unlock all worlds', category: 'misc' },
];

export interface AchievementState {
  levelsCompleted: number;
  totalStars: number;
  threeStarCount: number;
  streak: number;
  worldsUnlocked: number;
}

export function checkAchievements(state: AchievementState): Set<string> {
  const earned = new Set<string>();

  // Completion
  if (state.levelsCompleted >= 1) earned.add('first_step');
  if (state.levelsCompleted >= 20) earned.add('world_1');
  if (state.levelsCompleted >= 50) earned.add('world_2');
  if (state.levelsCompleted >= 100) earned.add('world_3');

  // Mastery
  if (state.totalStars >= 50) earned.add('star_collector');
  if (state.totalStars >= 200) earned.add('star_master');
  if (state.threeStarCount >= 10) earned.add('perfectionist');

  // Streak
  if (state.streak >= 3) earned.add('getting_started');
  if (state.streak >= 7) earned.add('dedicated');
  if (state.streak >= 30) earned.add('unstoppable');

  // Misc
  if (state.worldsUnlocked >= 3) earned.add('explorer');

  return earned;
}
